import { setLotteryWinner } from './../networkUtility/endpoints';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import * as endpoints from '../networkUtility/endpoints';
import { toggleLoader } from './loader';
import { getLocalStorage } from '../LocalStorage/GetLocalStorage';
import * as localStorageActiontype from '../LocalStorage/ActionTypes';
import { toggleNotificationVisibility } from './networkNotification';
import { NotificationType } from '../Utility/InterFacesAndEnum';

interface WinnerState {
    lotteryTickets: any,
    auctionTickets: any,
    isWinner: boolean,
    isAuctionWinner: boolean
}

interface ResultData {
    result: any
}
interface IsWinnerData {
    isWinner: boolean
}

const WinnerInitialState: WinnerState = {
    lotteryTickets: [],
    auctionTickets: [],
    isWinner: false,
    isAuctionWinner: false
}

interface AuctionPayload {
    // auctionId=57&memberType=A
    auctionId: any,

}

interface SetAuctionWinnerPayload {
    // auctionId=57&memberType=A
    auctionId: any,
    ticketNo: any
}

export const getLotteryPurchaseTickets = createAsyncThunk(`
get lottery tickets`,
    async (payload: any, { dispatch }) => {
        dispatch(toggleLoader({ isLoading: true }))
        await fetch(`${endpoints.getLotteryTicketById}${payload.id}`,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                    "Content-type": "application/json; charset=UTF-8",
                }
            }
        ).then((response) => {
            return response.json();
        }).then((data) => {
            // console.log(data)
            if (data.statusCode === 200) {
                // dispatch(toggleNotificationVisibility({
                //     isVisible: false,
                //     message: data.errorMsg,
                //     status: NotificationType.success
                // }))
                dispatch(setLotteryTickets({
                    result: data.result
                }))
                if (data.result !== undefined || data.result !== null) {
                    data.result.map((obj: any) => {
                        if (obj.isWinner === true) {
                            dispatch(setIsWinner({ isWinner: true }))

                        }
                    })
                }
            } else {
                // dispatch(toggleNotificationVisibility({
                //     isVisible: true,
                //     message: "Something went wrong.",
                //     status: NotificationType.success
                // }))
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(toggleLoader({ isLoading: false }))

        })
    }
)

export const setMannualLotteryWinner = createAsyncThunk(`
set mannual lottery winner`,
    async (payload: any, { dispatch }) => {
        dispatch(toggleLoader({ isLoading: true }))
        await fetch(endpoints.setLotteryWinner,
            {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                    "Content-type": "application/json; charset=UTF-8",
                },
                body: JSON.stringify(payload)
            }
        ).then((response) => {
            return response.json();
        }).then((data) => {
            console.log(data)
            if (data.statusCode === 200) {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    message: data.errorMsg,
                    status: NotificationType.success
                }))
                console.log(payload.lotteryGameId)
                dispatch(getLotteryPurchaseTickets({ id: payload.lotteryGameId }))
                dispatch(setIsWinner({ isWinner: true }))

            }
            else if (data.statusCode === 500) {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    message: data.errorMsg,
                    status: NotificationType.error
                }))
            } else {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    message: "Something went wrong.",
                    status: NotificationType.success
                }))
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(toggleLoader({ isLoading: false }))

        })
    }
)

export const clearLotteryWinner = createAsyncThunk(`
clear lottery winner`,
    async (payload: any, { dispatch }) => {
        dispatch(toggleLoader({ isLoading: true }))
        await fetch(`${endpoints.clearLotteryWinner}${payload.id}`,
            {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                    "Content-type": "application/json; charset=UTF-8",
                }
            }
        ).then((response) => {
            return response.json();
        }).then((data) => {
            // console.log(data)
            if (data.statusCode === 200) {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    message: data.errorMsg,
                    status: NotificationType.success
                }))

                dispatch(getLotteryPurchaseTickets(payload))
                dispatch(setIsWinner({ isWinner: false }))

                // dispatch(setLotteryTickets({
                //     result: data.result
                // }))
            } else {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    message: "Something went wrong.",
                    status: NotificationType.success
                }))
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(toggleLoader({ isLoading: false }))

        })
    }
)

export const getAuctionPurchaseTickets = createAsyncThunk(`
get auction tickets`,
    async (payload: AuctionPayload, { dispatch }) => {
        dispatch(toggleLoader({ isLoading: true }))
        await fetch(`${endpoints.getAuctionTicketById}${payload.auctionId}`,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                    "Content-type": "application/json; charset=UTF-8",
                }
            }
        ).then((response) => {
            return response.json();
        }).then((data) => {
            // console.log(data)
            if (data.statusCode === 200) {
                // dispatch(toggleNotificationVisibility({
                //     isVisible: false,
                //     message: data.errorMsg,
                //     status: NotificationType.success
                // }))
                dispatch(setAuctionTickets({
                    result: data.result
                }))
                if (data.result !== undefined || data.result !== null) {
                    data.result.map((obj: any) => {
                        if (obj.isWinner === true) {
                            dispatch(setIsAuctionWinner({ isWinner: true }))

                        }
                    })
                }
            } else {
                // dispatch(toggleNotificationVisibility({
                //     isVisible: true,
                //     message: "Something went wrong.",
                //     status: NotificationType.success
                // }))
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(toggleLoader({ isLoading: false }))

        })
    }
)

export const setMannualAuctionWinner = createAsyncThunk(`
set mannual auction winner`,
    async (payload: SetAuctionWinnerPayload, { dispatch }) => {
        dispatch(toggleLoader({ isLoading: true }))
        await fetch(endpoints.setAuctionWinner,
            {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                    "Content-type": "application/json; charset=UTF-8",
                },
                body: JSON.stringify(payload)
            }
        ).then((response) => {
            return response.json();
        }).then((data) => {
            console.log(data)
            if (data.statusCode === 200) {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    message: data.errorMsg,
                    status: NotificationType.success
                }))
                // console.log(payload.lotteryGameId)
                dispatch(getAuctionPurchaseTickets(payload))
                dispatch(setIsAuctionWinner({ isWinner: true }))
            } else if (data.statusCode === 500) {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    message: data.errorMsg,
                    status: NotificationType.error
                }))
            } else {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    message: "Something went wrong.",
                    status: NotificationType.success
                }))
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(toggleLoader({ isLoading: false }))

        })
    }
)

export const clearAuctionWinner = createAsyncThunk(`
clear auction winner`,
    async (payload: AuctionPayload, { dispatch }) => {
        dispatch(toggleLoader({ isLoading: true }))
        await fetch(`${endpoints.clearAuctionWinner}${payload.auctionId}`,
            {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                    "Content-type": "application/json; charset=UTF-8",
                }
            }
        ).then((response) => {
            return response.json();
        }).then((data) => {
            // console.log(data)
            if (data.statusCode === 200) {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    message: data.errorMsg,
                    status: NotificationType.success
                }))

                dispatch(getAuctionPurchaseTickets(payload))
                dispatch(setIsAuctionWinner({ isWinner: false }))
                // dispatch(setLotteryTickets({
                //     result: data.result
                // }))
            } else {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    message: "Something went wrong.",
                    status: NotificationType.success
                }))
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(toggleLoader({ isLoading: false }))

        })
    }
)


const winnerSlice = createSlice({
    name: "winner details slice",
    initialState: WinnerInitialState,
    reducers: {
        setLotteryTickets: (state, action: PayloadAction<ResultData>) => {
            return {
                ...state,
                lotteryTickets: action.payload.result
            }
        },
        setAuctionTickets: (state, action: PayloadAction<ResultData>) => {
            return {
                ...state,
                auctionTickets: action.payload.result,
            }
        },
        setIsWinner: (state, action: PayloadAction<IsWinnerData>) => {
            return {
                ...state,
                isWinner: action.payload.isWinner
            }
        },
        setIsAuctionWinner: (state, action: PayloadAction<IsWinnerData>) => {
            return {
                ...state,
                isAuctionWinner: action.payload.isWinner
            }
        },

    }
})

export const { setLotteryTickets, setAuctionTickets, setIsWinner, setIsAuctionWinner } = winnerSlice.actions;
export default winnerSlice.reducer;